module.exports = __webpack_public_path__ + "static/media/logo-sm-color.0e131cce.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/logo-sm-color.png
// module id = 384
// module chunks = 0